<template lang="pug">
	.contenedor
		.contieneFiltro(style="max-height:30px;min-height:30px;")
				.input-group.input-group-sm
					.input-group-prepend
						.input-group-text
							span.fa.fa-filter
					input.form-control(v-model="filtroNombre", placeholder="Filtrar por nombre")
					input.form-control(placeholder="Por segundos", v-model.number="filtroSegundos")
					.input-group-append
						.input-group-text seg.
		.contieneCabecera
			div.text-left(@click="setOrdenBuzon('ObjetoDescripcion')")
				span.mr-2.fa(:class="(ordenar.campo === 'ObjetoDescripcion') ? (ordenar.asc) ? 'fa-caret-up' : 'fa-caret-down' : ''")
				| Fichero
			div.text-right(@click="setOrdenBuzon('ObjetoDuracion')")
				span.mr-2.fa(:class="(ordenar.campo === 'ObjetoDuracion') ? (ordenar.asc) ? 'fa-caret-up' : 'fa-caret-down' : ''")
				| Duración
		.contieneTabla(
			tabindex="6"
			@keydown="teclaAbajo"
			@keyup="teclaArriba"
			ref="tablaContainer"
		)
			table.table.table-striped(style="width: 100%;")
				tbody
					tr(
						v-for="objeto in listaFicheros"
						:key="objeto.ObjetoID"
						@click="seleccionaObjeto(objeto)"
						@dblclick="agregarObjetos(objeto)"
						:class="(seleccion.indexOf(objeto) >= 0) ? 'bg-info' : ''"
						draggable
						@dragstart="arrastraObjeto($event, objeto)",
						@contextmenu="menuContextual($event, objeto)",
						:style="objeto.style"
						:ref="'objeto' + objeto.ObjetoID"
					)
						td.p-1(style="max-width: 0;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;") {{objeto.ObjetoDescripcion}}
						td.p-1.text-right(style="width:60px;") {{_getDuracionFisica(objeto.DuracionFisica)}}
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	props: ['bloque', 'buzon'],
	data () {
		return {
			ficheros: [],
			ordenar: {
				campo: 'ObjetoDescripcion',
				asc: true
			},
			teclas: {
				ctrl: false,
				shift: false
			},
			filtroNombre: '',
			filtroSegundos: null,
			indice: 0,
			objetoActivo: null,
			seleccion: []
		}
	},
	watch: {
		buzon: function (newVal, oldVal) {
			// Consultamos los ficheros del buzón
			if (newVal !== oldVal && newVal !== null) {
				this.getFicheros()
			}
		}
	},
	created () {
		if (this.buzon) {
			this.getFicheros()
		}
	},
	computed: {
		...mapGetters({
			parrilla: 'organizar-emisoras/insercionesParrilla'
		}),
		listaFicheros () {
			if (!this.ficheros) {
				return []
			}
			let arr = [].concat(this.ficheros)
			if (this.filtroNombre) {
				const reg = new RegExp(this.filtroNombre, 'ig')
				arr = arr.filter(fichero => {
					if (typeof fichero.ObjetoDescripcion === 'string') {
						return fichero.ObjetoDescripcion.match(reg)
					}
					return false
				})
			}
			if (this.filtroSegundos > 0) {
				arr = arr.filter(f => {
					return (Math.round(f.DuracionFisica / 10000000) === this.filtroSegundos)
				})
			}

			arr.sort((a, b) => {
				if (a[this.ordenar.campo]) {
					if (a[this.ordenar.campo] > b[this.ordenar.campo]) {
						return (this.ordenar.asc) ? 1 : -1
					} else {
						return (this.ordenar.asc) ? -1 : 1
					}
				} else {
					return 1
				}
			})

			return arr.splice(0, 500)
		}
	},
	methods: {
		getFicheros () {
			this.ficheros = []
			this.indice = null
			if (!this.buzon) {
				return
			}
			this.$http.post('organizar-emisoras/php/api/get-objetos-buzon.php?BuzonID=' + this.buzon.BuzonID)
				.then(res => {
					this.ficheros = res.data.listado.map(fichero => {
						fichero.style = this._getEstilo(fichero.BuzonColor)
						return fichero
					})

					if (this.ficheros.length > 0) {
						this.indice = 0
					}
				})
				.catch(this.$responseError)
		},
		teclaAbajo (e) {
			if (e.keyCode !== 9) {
				e.preventDefault()
				e.stopPropagation()
			}
			this.teclas.ctrl = e.ctrlKey
			this.teclas.shift = e.shiftKey
			if (e.keyCode === 40) {
				// Abajo
				this.seleccionaIndice(this.indice + 1)
			} else if (e.keyCode === 38) {
				// Arriba
				this.seleccionaIndice(this.indice - 1)
			} else if (e.keyCode === 32) {
				if (this.seleccion.length > 0) {
					this.$emit('reproducir', this.seleccion[0].ObjetoID)
				}
			} else if (e.keyCode === 35) {
				// Fin
				this.seleccionaIndice(this.listaFicheros.length - 1)
			} else if (e.keyCode === 36) {
				// Inicio
				this.seleccionaIndice(0)
			} else if (e.keyCode === 34) {
				// Av pag
				if (this.listaFicheros.length > 0) {
					const altoContainer = this.$refs.tablaContainer.offsetHeight
					const altoElemento = this.$refs['objeto' + this.listaFicheros[0].ObjetoID][0].offsetHeight

					// Cuantos caben por "página"
					const num = Math.floor(altoContainer / altoElemento)
					const indiceActual = this.listaFicheros.indexOf(this.seleccion[0])
					const indiceFinal = (this.listaFicheros[indiceActual + num]) ? indiceActual + num : this.listaFicheros.length - 1
					this.seleccion = [this.listaFicheros[indiceFinal]]
					this.$refs['objeto' + this.seleccion[0].ObjetoID][0].scrollIntoView({block: 'end', behavior: 'instant'})
				}
			} else if (e.keyCode === 33) {
				// arr pag
				if (this.listaFicheros.length > 0) {
					const altoContainer = this.$refs.tablaContainer.offsetHeight
					const altoElemento = this.$refs['objeto' + this.listaFicheros[0].ObjetoID][0].offsetHeight

					// Cuantos caben por "página"
					const num = Math.floor(altoContainer / altoElemento)
					const indiceActual = this.listaFicheros.indexOf(this.seleccion[0])
					const indiceFinal = (indiceActual - num >= 0) ? indiceActual - num : 0
					this.seleccion = [this.listaFicheros[indiceFinal]]
					this.$refs['objeto' + this.seleccion[0].ObjetoID][0].scrollIntoView({block: 'end', behavior: 'instant'})
				}
			} else {
				console.log(e.keyCode)
			}
		},
		teclaArriba (e) {
			e.preventDefault()
			e.stopPropagation()
			this.teclas.ctrl = e.ctrlKey
			this.teclas.shift = e.shiftKey
		},
		setOrdenBuzon (campo) {
			if (this.ordenar.campo === campo) {
				this.ordenar.asc = !this.ordenar.asc
			} else {
				this.ordenar.campo = campo
				this.ordenar.asc = true
			}
		},
		seleccionaIndice (i) {
			const tamano = this.listaFicheros.length
			this.indice = (i >= tamano) ? 0 : (i < 0) ? tamano - 1 : i
			this.seleccion = [this.listaFicheros[this.indice]]
			this.$refs['objeto' + this.seleccion[0].ObjetoID][0].scrollIntoView({block: 'end', behavior: 'instant'})
		},

		agregarObjetos (objeto) {
			this.$store.dispatch('organizar-emisoras/programarInserciones', {
				ficheros: [objeto.ObjetoID],
				posicion: (this.parrilla.length > 0) ? this.parrilla[this.parrilla.length - 1].ProgramacionOrden + 1 : 1
			})
		},

		seleccionaObjeto (objeto) {
			this.objetoActivo = objeto
			if (this.teclas.ctrl) {
				const idx = this.seleccion.indexOf(objeto)
				if (idx >= 0) {
					this.seleccion.splice(idx, 1)
				} else {
					this.seleccion.push(objeto)
				}
			} else if (this.teclas.shift) {
				if (this.seleccion.length === 0) {
					this.seleccion = [objeto]
				} else {
					// Hayamos el índice más bajo de la selección
					const indiceSeleccion = this.listaFicheros.indexOf(objeto)
					let ind = null
					for (let i = 0; i < this.seleccion.length; i++) {
						const e = this.listaFicheros.indexOf(this.seleccion[i])
						ind = (ind === null || e < ind) ? e : ind
					}

					// Ahora comprobamos si es mayor que el seleccionado
					let primero = (ind > indiceSeleccion) ? indiceSeleccion : ind
					let ultimo = (ind > indiceSeleccion) ? ind : indiceSeleccion

					this.seleccion = []

					for (let p = primero; p <= ultimo; p++) {
						this.seleccion.push(this.listaFicheros[p])
					}
				}
			} else {
				this.seleccion = [objeto]
			}

			this.indice = this.listaFicheros.indexOf(objeto)
		},

		arrastraObjeto (e, objeto) {
			if (this.seleccion.indexOf(objeto) < 0) {
				this.seleccionaObjeto(objeto)
			}
			e.dataTransfer.setData('text/json', JSON.stringify(this.seleccion))
		},

		menuContextual (e, objeto) {
			e.preventDefault()
			e.stopPropagation()
			if (this.seleccion.indexOf(objeto) < 0) {
				this.seleccionaObjeto(objeto)
			}
			const menu = {
				titulo: 'Acciones',
				evento: e,
				items: []
			}

			menu.items.push({
				texto: 'Reproducir',
				icono: 'fa fa-play',
				activo: true,
				callback: () => {
					this.$emit('reproducir', objeto.ObjetoID)
				}
			})

			menu.items.push({
				texto: 'Insertar',
				icono: 'fa fa-plus',
				activo: (typeof this.bloque === 'object'),
				callback: () => {
					this.$store.dispatch('organizar-emisoras/programarInserciones', {
						ficheros: this.seleccion.map(o => o.ObjetoID),
						posicion: (this.parrilla.length > 0) ? this.parrilla[this.parrilla.length - 1].ProgramacionOrden + 1 : 1
					})
				}
			})

			this.$store.commit('contextual/mostrar', menu)
		},

		// MÉTODOS PRIVADOS
		_getEstilo (Color) {
			let hex = Color.toString(16)
			const reverse = (str) => {
				return (str === '') ? '' : reverse(str.substr(1)) + str.charAt(0)
			}
			hex = reverse(hex)

			// Calculamos si la cadena es de 6
			while (hex.length < 6) {
				hex = hex + '0'
			}

			hex = (hex === '000000') ? 'ffffff' : hex
			const getContrastYIQ = (r, g, b, opacidad) => {
				opacidad = 1 + opacidad
				const yiq = ((r * 299 * opacidad) + (g * 587 * opacidad) + (b * 114 * opacidad)) / 1000
				return (yiq >= 128) ? 'black' : 'white'
			}

			hex = hex.replace('#', '')
			const r = parseInt(hex.substring(0, 2), 16)
			const g = parseInt(hex.substring(2, 4), 16)
			const b = parseInt(hex.substring(4, 6), 16)
			const opacidad = 0.6

			hex = 'rgba(' + r + ', ' + g + ', ' + b + ', ' + opacidad + ')'

			return {
				backgroundColor: hex,
				color: getContrastYIQ(r, g, b, opacidad)
			}
		},
		_getDuracionFisica (dur) {
			let valor = Math.round(dur / 10000000)
			let neg = (valor < 0)
			valor = (valor < 0) ? valor * -1 : valor
			let h = '00'
			let m = '00'
			let s = '00'
			let decimas = '000'
			decimas = (valor.toString().match(/\./)) ? valor.toString().split('.')[1] : '000'

			if (valor >= 3600) {
				h = Math.floor(valor / 3600)
				h = (h < 10) ? '0' + h : h
				valor = valor % 3600
			}

			if (valor >= 60) {
				m = Math.floor(valor / 60)
				m = (m < 10) ? '0' + m : m
				valor = valor % 60
			}

			s = parseInt(valor)
			s = (s < 10) ? '0' + s : s

			decimas = decimas.toString()
			while (decimas.length < 3) {
				decimas = decimas + '0'
			}

			const menos = (neg) ? '-' : ''
			return menos + '' + h + ':' + m + ':' + s
		}
	}
}
</script>

<style scoped>
	.contenedor {
		display: flex;
		flex-direction: column;
		align-content: stretch;
		align-items: stretch;
		align-self: stretch;
	}
	.contieneFiltro {
		position: relative;
		display: block;
	}
	.contieneCabecera {
		position: relative;
		display: flex;
		flex-grow: 1;
		flex-basis: 0;
		flex-direction: row;
		width: 100%;
		overflow: hidden;
		align-items: stretch;
		align-self: stretch;
		align-content: stretch;
		min-height: 25px;
		max-height: 25px;
		background-color: #333333;
		color: white;
	}
	.contieneCabecera > div {
		cursor: pointer;
		flex-grow: 1;
		flex-shrink: 1;
		padding: 3px;
		font-weight: bold;
	}
	.contieneTabla {
		flex-grow: 1;
		flex-basis: auto;
		overflow-y: auto;
		flex-shrink: 1;
		overflow-y: auto;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/organizar-emisoras/vue/paginas/organizar/objetos-buzon.vue